module.exports = __webpack_public_path__ + "static/media/ceilings_lcs_10y_n.0ec656d5.csv";